"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileDropZone;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactDropzone = require("react-dropzone");
var _reactIntl = require("react-intl");
var _excluded = ["acceptedFormats", "acceptedFormatsTranslationKey", "disabled", "downloadExampleTranslationKey", "dropTranslationKey", "errorMessage", "exampleFileUrl", "failureNumberPath", "failurePrimaryTranslationKey", "failures", "failureSecondaryTranslationKey", "failureSecondaryTranslationKeyWithoutField", "id", "multiple", "onDrop", "selectFilesTranslationKey", "selectFileTranslationKey", "successMessage"];
var _br;
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    alignCenter: {
      textAlign: 'center'
    },
    browseButton: {
      margin: theme.spacing(2, 0)
    },
    dropzone: {
      '&:last-child': {
        marginBottom: 0
      },
      alignItems: 'center',
      borderColor: theme.palette.primary.main,
      borderRadius: 5,
      borderStyle: 'dashed',
      borderWidth: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1)
    },
    dropzoneAccept: {
      backgroundColor: theme.palette.primary.light,
      borderColor: theme.palette.primary.main
    },
    dropzoneActive: {
      borderColor: theme.palette.primary.light
    },
    dropzoneDisabled: {
      opacity: 0.1
    },
    dropzoneReject: {
      '& > :nth-last-child(n+3)': {
        color: theme.palette.grey[500]
      },
      borderColor: theme.palette.grey[500]
    },
    leftIcon: {
      marginRight: theme.spacing(1),
      verticalAlign: 'text-top'
    },
    uploadIcon: {
      height: 100,
      width: 100
    }
  };
});
function Failures(_ref) {
  var _FormattedMessage, _FormattedMessage2;
  var failureNumberPath = _ref.failureNumberPath,
    failurePrimaryTranslationKey = _ref.failurePrimaryTranslationKey,
    failures = _ref.failures,
    failureSecondaryTranslationKey = _ref.failureSecondaryTranslationKey,
    failureSecondaryTranslationKeyWithoutField = _ref.failureSecondaryTranslationKeyWithoutField,
    id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    id: id,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.List, {
    disablePadding: true,
    id: "".concat(id, "List")
  }, failures.map(function (failure, i) {
    var _failure$errors;
    var numberField = failureNumberPath && failureNumberPath.split('.').reduce(function (acc, field) {
      return (acc == null ? void 0 : acc[field]) || null;
    }, failure);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement(_material.ListItem, {
        key: numberField || i,
        divider: true,
        id: "".concat(id, "List").concat(i)
      }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
        id: "".concat(id, "List").concat(i, "Text"),
        primary: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: failurePrimaryTranslationKey,
          values: {
            number: numberField || ''
          }
        }),
        secondary: ((_failure$errors = failure.errors) == null ? void 0 : _failure$errors.length) > 0 ? failure.errors.map(function (error, j) {
          var _error$message;
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _react.default.createElement(_react.default.Fragment, {
              key: j
            }, error.field || !failureSecondaryTranslationKeyWithoutField ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: failureSecondaryTranslationKey,
              values: {
                field: error.field || ''
              }
            }) : _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: failureSecondaryTranslationKeyWithoutField
            })), ' ', (_error$message = error.message) != null && _error$message.id ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: error.message.id,
              values: error.message.values
            }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, error.message), _br || (_br = /*#__PURE__*/_react.default.createElement("br", null)))
          );
        }) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: failureSecondaryTranslationKey
        }))
      }))
    );
  })));
}
function FileDropZone(_ref2) {
  var acceptedFormats = _ref2.acceptedFormats,
    acceptedFormatsTranslationKey = _ref2.acceptedFormatsTranslationKey,
    disabled = _ref2.disabled,
    downloadExampleTranslationKey = _ref2.downloadExampleTranslationKey,
    dropTranslationKey = _ref2.dropTranslationKey,
    errorMessage = _ref2.errorMessage,
    exampleFileUrl = _ref2.exampleFileUrl,
    failureNumberPath = _ref2.failureNumberPath,
    failurePrimaryTranslationKey = _ref2.failurePrimaryTranslationKey,
    failures = _ref2.failures,
    failureSecondaryTranslationKey = _ref2.failureSecondaryTranslationKey,
    failureSecondaryTranslationKeyWithoutField = _ref2.failureSecondaryTranslationKeyWithoutField,
    id = _ref2.id,
    _ref2$multiple = _ref2.multiple,
    multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
    onDrop = _ref2.onDrop,
    selectFilesTranslationKey = _ref2.selectFilesTranslationKey,
    selectFileTranslationKey = _ref2.selectFileTranslationKey,
    successMessage = _ref2.successMessage,
    other = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var classes = useStyles();
  var _useDropzone = (0, _reactDropzone.useDropzone)((0, _extends2.default)({
      accept: acceptedFormats.join(', '),
      disabled,
      multiple,
      onDrop
    }, other)),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    id: id,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.alignCenter,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: "".concat(id, "Upload")
  }, getRootProps({
    className: (0, _classnames.default)(classes.dropzone, isDragActive && classes.dropzoneActive, isDragAccept && classes.dropzoneAccept, isDragReject && classes.dropzoneReject, disabled && classes.dropzoneDisabled)
  })), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "primary",
    id: "".concat(id, "UploadButton")
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.CloudUpload, {
    className: classes.uploadIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "Title"),
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: dropTranslationKey
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "SubTitle"),
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: acceptedFormatsTranslationKey,
    values: {
      formats: acceptedFormats.reduce(function (acc, format) {
        if (format.startsWith('.')) {
          var fileFormat = format.substring(1).toUpperCase();
          return [].concat((0, _toConsumableArray2.default)(acc), [fileFormat]);
        }
        return acc;
      }, []).join(', ')
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.browseButton,
    color: "primary",
    disabled: disabled || isDragReject,
    id: "".concat(id, "SelectFilesButton"),
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: multiple ? selectFilesTranslationKey : selectFileTranslationKey
  }))), exampleFileUrl && /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "black",
    href: exampleFileUrl,
    id: "".concat(id, "DownloadExampleButton")
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.CloudDownload, {
    className: classes.leftIcon
  }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: downloadExampleTranslationKey
  }))), (successMessage || errorMessage) && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, successMessage && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "secondary",
    id: "".concat(id, "SuccessMessage"),
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Done, {
    className: classes.leftIcon
  }), successMessage), errorMessage && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "error",
    id: "".concat(id, "ErrorMessage"),
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Clear, {
    className: classes.leftIcon
  }), errorMessage)), (failures == null ? void 0 : failures.length) > 0 && /*#__PURE__*/_react.default.createElement(Failures, {
    failureNumberPath: failureNumberPath,
    failurePrimaryTranslationKey: failurePrimaryTranslationKey,
    failures: failures,
    failureSecondaryTranslationKey: failureSecondaryTranslationKey,
    failureSecondaryTranslationKeyWithoutField: failureSecondaryTranslationKeyWithoutField,
    id: "".concat(id, "Failures")
  }));
}